export default {
  LOGIN: 'LOGIN',
  RESERVATION_CANCEL: 'RESERVATION_CANCEL',
  RESERVATION_CONFIRM: 'RESERVATION_CONFIRM',
  RESERVATION_INFO: 'RESERVATION_INFO',
  RESERVATION_SUCCESS: 'RESERVATION_SUCCESS',
};



/** WEBPACK FOOTER **
 ** ./app/constants/ModalTypes.js
 **/